module.exports = __webpack_public_path__ + "img/account.c17b275a.png";